var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",staticClass:"ui-button-new",class:[
        '_theme_' + _vm.theme,
        { _disabled: _vm.isDisabled },
    ],attrs:{"type":_vm.type ? _vm.type : null,"href":_vm.href ? _vm.href : null,"target":_vm.isNewWindowNeeded || null},on:{"click":_vm.clickHandler}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }